import { api } from '@/lib/utils/axios'
import Cookies from 'js-cookie'
import { useAuthStore } from '@/lib/stores/authStore'

export async function login(params: { email: string; password: string; company_code: string }) {
  try {
    const res = await api.post('/front/v1/auth/users/login', {
      email: params.email,
      password: params.password,
      company_code: params.company_code,
    })

    if (!res.data || !res.data.data) {
      throw new Error('Invalid response format')
    }

    const { access_token, refresh_token } = res.data.data

    if (!access_token || !refresh_token) {
      throw new Error('Missing tokens in response')
    }

    Cookies.set('axp_access_token', access_token)
    Cookies.set('axp_refresh_token', refresh_token)
    useAuthStore.getState().setTokens(access_token, refresh_token)

    return res.data
  } catch (error) {
    console.error('Login error:', error)
    throw error
  }
}

export async function logout(params: { refresh_token: string }) {
  try {
    const res = await api.post('/front/v1/auth/users/logout', {
      refresh_token: params.refresh_token,
    })
    return res.data
  } catch (error) {
    console.error('Logout error:', error)
    throw error
  }
}

export async function forgetPassword(params: { company_code: string; email: string }) {
  try {
    const res = await api.post('/front/v1/auth/users/forget-password', {
      company_code: params.company_code,
      email: params.email,
    })
    return res.data
  } catch (error) {
    console.error('Forget password error:', error)
    throw error
  }
}

export async function resetPassword(params: {
  token: string
  password: string
  password_confirm: string
}) {
  try {
    const res = await api.post('/front/v1/auth/users/reset-password', {
      token: params.token,
      password: params.password,
      password_confirm: params.password_confirm,
    })

    // const { access_token, refresh_token } = res.data.data

    // if (!access_token || !refresh_token) {
    //   throw new Error('Missing tokens in response')
    // }

    // Cookies.set('axp_access_token', access_token)
    // Cookies.set('axp_refresh_token', refresh_token)

    // useAuthStore.getState().setTokens(access_token, refresh_token)

    return res.data
  } catch (error) {
    console.error('Reset password error:', error)
    throw error
  }
}

export async function checkResetPasswordToken(params: { token: string }) {
  try {
    const res = await api.get('/front/v1/auth/users/reset-password/check-token', {
      params: {
        token: params.token,
      },
    })
    return res.data
  } catch (error) {
    console.error('Check reset password token error:', error)
    throw error
  }
}

export async function getCompany(url: string, signal?: AbortSignal) {
  try {
    const res = await api.get('/front/v1/auth/companies/public-info', {
      params: {
        url,
      },
      // ✅ 타임아웃 설정 (10초)
      timeout: 10000,
      // ✅ React Query의 AbortSignal 연동
      signal,
      // ✅ 재시도 설정 (axios 레벨에서는 재시도 안 함 - React Query에서 처리)
      validateStatus: status => status >= 200 && status < 300,
    })
    return res.data
  } catch (error) {
    console.error('[getCompany] Unexpected error:', error)
    throw error
  }
}

export async function getCompanyInfo() {
  try {
    const res = await api.get('/front/v1/auth/companies/info')
    return res.data
  } catch (error) {
    console.error('Get company info error:', error)
    throw error
  }
}

export async function getPrograms(params: { page: number; limit: number } = { page: 1, limit: 6 }) {
  try {
    const res = await api.get('/front/v1/programs/programs/public-info', {
      params,
    })
    return res.data
  } catch (error) {
    console.error('Get programs error:', error)
    throw error
  }
}

export async function getProgramInfo(id: string) {
  try {
    const res = await api.get(`/front/v1/programs/programs/public-info/${id}/applications`)
    return res.data
  } catch (error) {
    console.error('Get program info error:', error)
    throw error
  }
}
